import React from 'react';
import Link from '../common/TrackedLink';

const FaqCategories = ({ category }) => {
	let categoryImage = 'help-icon.png';
	let category2xImage = 'help-icon@2x.png';
	const categoryFriendlyId = category.categoryName.toLowerCase().replace(/\s+/g, '-');
	const categoryUrl = `/support/faqs#${categoryFriendlyId}`;
	if (categoryFriendlyId === 'batteries') {
		categoryImage = 'batteries-icon.png';
		category2xImage = 'batteries-icon@2x.png';
	} else if (categoryFriendlyId === 'how-we-test-our-products') {
		categoryImage = 'how-we-test-icon.png';
		category2xImage = 'how-we-test-icon@2x.png';
	} else if (categoryFriendlyId === 'i-lost-my-key-or-combination') {
		categoryImage = 'combo-icon.png';
		category2xImage = 'combo-icon@2x.png';
	} else if (categoryFriendlyId === 'warranties-and-guarantees') {
		categoryImage = 'warranties-icon.png';
		category2xImage = 'warranties-icon@2x.png';
	}

	return (
		<li>
			<img
				src={ require(`../../resources/img/icons/${categoryImage}`) }
				srcSet={ `${require(`../../resources/img/icons/${category2xImage}`)} 2x` }
				alt={ category.categoryName }
			/>
			<h3>{ category.categoryName }</h3>
			<Link
				className="arrow-link"
				to={ categoryUrl }
				trackEvent="FAQ"
				trackEventCategory="Support"
				trackEventAction="FAQ Link"
				trackEventLabel={ category.categoryName }
			>
				View Questions
			</Link>
		</li>
    );
};

export default FaqCategories;


// WEBPACK FOOTER //
// ./src/pages/support/FaqCategories.js